import { render, staticRenderFns } from "./regTypeAutoFormField.vue?vue&type=template&id=03577ca7"
import script from "./regTypeAutoFormField.vue?vue&type=script&lang=js"
export * from "./regTypeAutoFormField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports